var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{style:({
	transformOrigin: (_vm.radius + "px " + _vm.radius + "px"),
	transform: ("rotate(" + (_vm.index * _vm.arcLength) + "deg)"),
})},[_c('svg',{attrs:{"viewBox":("0 0 " + _vm.cx2 + " " + _vm.radius),"width":_vm.cx2,"height":_vm.radius,"x":_vm.radius,"y":"0"}},[_c('path',{staticClass:"slice",attrs:{"d":_vm.path,"fill":_vm.fill}}),_c('path',{attrs:{"d":"M0 0 0 250","fill":"none","stroke-width":"4","stroke":"url(#border)"}}),_c('g',{style:({
			transformOrigin: ("0 " + _vm.radius + "px"),
			transform: ("rotate(" + (_vm.arcLength / 2) + "deg)"),
		})},[_c('use',{attrs:{"xlink:href":("#" + _vm.symbol),"x":_vm.iconX,"y":"20","width":_vm.iconWidth,"fill":_vm.iconFill}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }